<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="500"
    >
        <v-card>
            <v-toolbar
                color="primary"
                elevation="0"
            >
                <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="white"
                    icon
                    :disabled="loading"
                    @click="closeWithAction(false)"
                >
                     <v-icon style="color:white !important">mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="pt-5 black--text text-center">
                {{ message ? message : $t('areYouSureText') }}
            
            <v-divider class="mt-5"></v-divider>
            <v-card-actions class="px-0">
                <v-checkbox
                    v-if="showDontAskAgain"
                    v-model="dontAskAgain"
                    :label="dontAskAgainLabel || $t('dueDiligence.createWithoutRiskAssessment.doNotShowAgain')"
                    hide-details
                    class="mt-0 pt-0"
                    @click.stop
                />
                <v-spacer></v-spacer>
                <v-btn
                    v-if="cancelBtnText"
                    color="primary darken-1"
                    text
                    :disabled="loading"
                    @click="closeWithAction(false)"
                    :outlined="cancelBtnOutlined"
                >
                    {{ cancelBtnText? cancelBtnText : 'Disagree' }}
                </v-btn>
                <v-btn
                    depressed
                    color="primary"
                    :loading="loading"
                    :disabled="loading"
                    @click="continueWithAction(true)"
                >
                    {{ confirmBtnText? confirmBtnText : 'Agree' }}
                </v-btn>
            </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: false
        },
        confirmBtnText: {
            type: String,
            required: false
        },
        cancelBtnText: {
            type: String,
            required: false
        },
        confirmData: {
            type: Object,
            required: false
        },
        cancelBtnOutlined: {
            type: Boolean,
            required: false
        },
        showDontAskAgain: {
            type: Boolean,
            default: false
        },
        dontAskAgainLabel: {
            type: String,
            required: false
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dontAskAgain: false,
        }
    },
    watch: {
        dialog(isOpen) {
            if (isOpen) {
                this.dontAskAgain = false;
            }
        },
    },
    methods: {
        closeWithAction(action) {
            if (this.loading) return;
            this.$emit('cancel:action', action, this.confirmData, this.dontAskAgain)
        },
        continueWithAction(action) {
            if (this.loading) return;
            this.$emit('continue:action', action, this.confirmData, this.dontAskAgain)
        }
    }
}
</script>
